import React from "react";
import cookieIcon from "../assets/img/cookie-icon.png"; 

export default function CookieFloatingButton() {
  const handleClick = () => {
    // فتح مدير الكوكيز
    window.dispatchEvent(
      new CustomEvent("cookie-manager", { detail: "open-cookie-manager" })
    );
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Cookie-Einstellungen öffnen"
      className="fixed bottom-5 left-5 z-[9997]   hover:scale-125 transition-all duration-200"
    >
      <img
        src={cookieIcon}
        alt="Cookie Icon"
        className="w-24 h-24 object-contain"
      />
    </button>
  );
}
